import type { DocumentCardProps } from '../../Documents/DocumentCard';
import { DocumentCard } from '../../Documents/DocumentCard';

export function PetDocumentCard(props: Omit<DocumentCardProps, 'deleteConfirmationText'>) {
  return (
    <DocumentCard
      {...props}
      deleteConfirmationText="This also deletes it from all applications you have not submitted."
    />
  );
}
